import React from 'react'
import ReactDOM from 'react-dom'
import { X } from 'lucide-react'
import { WithdrawView } from './evm/index'
import { WithdrawProps } from '../types'
// i18n
import { useTranslation } from '@/hooks'
// shared
import { isMpcWalletType } from '@/components/shared/utils'

export const Withdraw: React.FC<WithdrawProps> = ({
  isOpen,
  isLoading = false,
  onClose,
  config: _config,
  currentActiveAccount,
  chains,
  defaultChainId,
  defaultTokenAddress,
  defaultAmount = '',
  metadata,
  currentEquity = 5000,
  platformBalance = '0', // 默认值为 '0'
  fee,
  wagmiHooks,
  onWithdraw,
  onChainChange,
  onTokenChange,
  onAmountChanged,
}) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  // Render at document.body via portal to ensure global overlay above all
  return ReactDOM.createPortal(
    <div
      className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen"
      style={{
        zIndex: 98,
      }}
    >
      {/* overlay + panel container */}
      <div
        className="fixed top-0 left-0 right-0 bottom-0 z-[99] flex items-center justify-center"
        style={{
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
        }}
        onClick={() => {
          onClose()
        }}
        aria-hidden="true"
      >
        {/* panel */}
        <div
          className="relative w-[420px] max-h-[85vh] bg-fill-page-secondary overflow-auto rounded-lg p-6 shadow-xl"
          onClick={e => {
            e.stopPropagation()
          }}
        >
          {/* header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-white">
              {t('withdraw.withdraw')}
            </h2>
            <button
              className="text-gray-400 hover:text-gray-200 transition-colors"
              onClick={onClose}
              aria-label="Close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          {/* 提现视图 */}
          <WithdrawView
            chains={chains}
            address={
              isMpcWalletType(currentActiveAccount)
                ? currentActiveAccount.smartWalletAddress
                : currentActiveAccount.ethAddress
            }
            walletType={isMpcWalletType(currentActiveAccount) ? 'mpc' : 'evm'}
            defaultChainId={defaultChainId}
            defaultTokenAddress={defaultTokenAddress}
            defaultAmount={defaultAmount}
            metadata={metadata}
            currentEquity={currentEquity}
            platformBalance={platformBalance} // 传递平台余额
            fee={fee} // 传递手续费
            isLoading={isLoading} // 传递 loading 状态
            wagmiHooks={wagmiHooks}
            onWithdraw={onWithdraw}
            onClose={onClose}
            onChainChange={onChainChange}
            onTokenChange={onTokenChange}
            onAmountChanged={onAmountChanged}
          />
        </div>
      </div>
    </div>,
    document.body
  )
}
